import React, { Component } from 'react';
import { Row, Col, Label, MenuItem } from 'react-bootstrap';
import { FieldArray } from 'redux-form';
import FormSectionHeading from 'components/atoms/form/FormSectionHeading';
import DropdownButton from 'components/atoms/buttons/DropdownButton';
import CustomChannel from './CustomChannel';


class CustomChannelList extends Component {
    constructor(props) {
        super(props);
        // We have to track this arbitrary state to ensure the 'key' given to every custom channel card
        // render is unique so that we always ensure that the DOM updates the way we expect it to.
        this.state = {
            nextCustomChannelKey: 100000000
        };
        this.embeddedLinkBottomRef = React.createRef();
        this.createNewCustomChannel = this.createNewCustomChannel.bind(this);
        this.renderCustomChannels = this.renderCustomChannels.bind(this);
    }

    createNewCustomChannel(platform) {
        const baseCustomChannel = {
            name: null,
            frameUrl: null,
            platform,
            new: true,
            key: this.state.nextCustomChannelKey,
            enabled: false
        };

        window.scrollTo({
            top: this.embeddedLinkBottomRef.current.offsetTop,
            behavior: 'smooth'
        });

        this.props.handleNewCustomChannel(baseCustomChannel);
        this.setState({
            nextCustomChannelKey: this.state.nextCustomChannelKey + 1
        });
    }

    renderCustomChannels({ fields }) {
        const result = [
            <Row key="control">
                <Col xs={12}>
                    <DropdownButton title="ADD NEW CUSTOM CHANNEL" id="dropdown-add-new-custom-channel">
                        <MenuItem eventKey="redash" onClick={() => this.createNewCustomChannel('redash')}>Redash</MenuItem>
                        <MenuItem eventKey="gds" onClick={() => this.createNewCustomChannel('gds')}>Google Data Studio</MenuItem>
                        <MenuItem eventKey="other" onClick={() => this.createNewCustomChannel('other')}>Other</MenuItem>
                    </DropdownButton>
                </Col>
            </Row>
        ];

        const embeddedLinkRenders = fields.map((fieldKey, index) => {
            const embeddedLink = fields.get(index);
            return (
                <CustomChannel
                    dispatch={this.props.dispatch}
                    formName={this.props.formName}
                    key={`${embeddedLink.platform}-${embeddedLink.slug || embeddedLink.key}`}
                    embeddedLink={embeddedLink}
                    fieldKey={fieldKey}
                    handleDelete={() => fields.remove(index)}
                />
            );
        });

        return result.concat(embeddedLinkRenders);
    }

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col xs={12}>
                        <FormSectionHeading>
                            Custom Channels
                            <Label bsStyle="primary" style={{ marginLeft: '5px' }}>Beta</Label>
                        </FormSectionHeading>
                        <p>
                            Custom channels allow you to embed custom reports from Redash, Google Data Studio,
                            and other sources into the dashboard. The links will appear in the order
                            they are listed below and are hidden from the client until you enable "Visible to Client."
                        </p>
                    </Col>
                </Row>
                <FieldArray name='meta.embeddedLinks' component={this.renderCustomChannels} />
                <hr ref={this.embeddedLinkBottomRef} />
            </React.Fragment>
        );
    }
}

export default CustomChannelList;



// WEBPACK FOOTER //
// ./src/components/organisms/entity/edit/CustomChannelList.js